const BASE = '$root'

export const SIDEBAR_VISIBLE = `${BASE}/sidebar/visible`
export const CURRENT_MENU = `${BASE}/current/menu`
export const GLOBAL_BUSY = `${BASE}/busy`
export const CURRENT_PAGE = `${BASE}/current/page`